export default __webpack_public_path__ + "static/media/prod-img-3.6e7e33e5.webp";